export enum PopupType {
    ADD  = 'ADD',
    EDIT = 'EDIT'
}
